import { AxiosResponse, AxiosStatic } from "axios";
import { IFullCourse } from "../../components/course-author/types";
import { IMultiLocaleCourse } from "../../components/course-author/types";

export interface ICoursesApiDependencies {
  axios: AxiosStatic;
  saltcomplianceApiRoot: string;
}

export interface ICoursesApi {
  create: (course: IFullCourse, accountId: string) => Promise<AxiosResponse>;
  getEditableByRelativeTo: (accountId: string, organizationId: string) => Promise<AxiosResponse>;
  getInstancesByAccount: (accountId: string) => Promise<AxiosResponse>;
  createCourse: (accountId: string, course: IMultiLocaleCourse) => Promise<AxiosResponse>;
  getDashboardEditableByRelativeTo: (accountId: string, organizationId: string) => Promise<AxiosResponse>;
}

export default class CoursesApi implements ICoursesApi {
  private readonly apiRoot: string;
  private readonly axios: AxiosStatic;

  constructor(dependencies: ICoursesApiDependencies) {
    this.apiRoot = dependencies.saltcomplianceApiRoot;
    this.axios = dependencies.axios;
  }

  public create = (course: IFullCourse, accountId: string) => {
    return this.axios.post(`${this.apiRoot}/courses?desired-course-type=multi-locale-koala`, course.state, {
      params: { activeUser: accountId },
    });
  };

  public getEditableByRelativeTo = (accountId: string, organizationId: string) => {
    return this.axios.get(
      `${this.apiRoot}/collections/courses/editableBy/${accountId}/relativeToOrg/${organizationId}`,
      {
        params: { activeUser: accountId },
      }
    );
  };

  public getInstancesByAccount = (accountId: string) => {
    return this.axios.get(`${this.apiRoot}/collections/courseInsts/byAccount/${accountId}`, {
      params: { activeUser: accountId },
    });
  };

  public createCourse = (activeUser: string, course: IMultiLocaleCourse) =>
    this.axios.post(`${this.apiRoot}/courses?desired-course-type=multi-locale-koala`, course, {
      params: { activeUser },
    });

  public getDashboardEditableByRelativeTo = (accountId: string, organizationId: string) => {
    return this.axios.get(
      `${this.apiRoot}/collections/dashboard/courses/editableBy/${accountId}/relativeToOrg/${organizationId}`,
      {
        params: { activeUser: accountId },
      }
    );
  };
}
